var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-list',{attrs:{"id":"nav-steps"}},[_c('f7-list-item',{attrs:{"title":"initial","data-step":"-1"},on:{"click":_vm.setStep}}),_vm._v(" "),_vm._l((_vm.steps),function(step){return _c('f7-list-item',{key:step.step,attrs:{"title":step.lib,"data-step":step.step},on:{"click":_vm.setStep}})})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25201bbf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/partial/panel-left.vue
// module id = null
// module chunks = 